import React from 'react'
import Certifications from '../components/Certifications'

const CertificationsPage = () => {
  return (
    <div className="pt-16">
      <Certifications />
    </div>
  )
}

export default CertificationsPage
